export const environment = {
  production: false,
  version: '0.0.0-development',
  THEWALL_URL: 'http://localhost:4000/graphql',
};
